import type { SiteName } from '@/scopes/common/domain/types'

const BOOKING_URLS_MVC: Partial<Record<SiteName, string>> = {
  sunwebnl: '/mijn-sunweb/boeking',
  sunwebbenl: '/nl/mijn-sunweb/boeking',
  sunwebfr: '/mon-sunweb/booking',
  sunwebbefr: '/fr/mon-sunweb/booking',
  sunwebdk: '/mit-sunweb/booking',
  sunwebde: '/mein-sunweb/buchungsseite',
  sunwebse: '/mitt-sunweb/booking',
  sunwebuk: '/my/booking',
  elizanl: '/mijn-eliza/boeking',
  elizabe: '/mijn-eliza/boeking',
}

const BOOKING_URLS: Partial<Record<SiteName, string>> = {
  sunwebnl: '/mijn-sunweb/boeking-details',
  sunwebbenl: '/nl/mijn-sunweb/boeking-details',
  sunwebbefr: '/fr/mon-sunweb/details-reservation',
  sunwebfr: '/mon-sunweb/details-reservation',
  sunwebdk: '/mit-sunweb/booking-detaljer',
  sunwebde: '/mein-sunweb/buchungs-details',
  sunwebse: '/mitt-sunweb/boknings-detaljer',
  sunwebuk: '/my/booking-details',
  elizanl: '/mijn-eliza/boeking-details',
  elizabe: '/mijn-eliza/boeking-details',
}

export function buildBookingUrl(
  siteName: SiteName,
  bookingNumber: string,
  showNewBookingDetailPage?: boolean,
): string | undefined {
  const bookingBaseUrl = showNewBookingDetailPage
    ? BOOKING_URLS[siteName]
    : BOOKING_URLS_MVC[siteName]
  if (!bookingBaseUrl) {
    return undefined
  }

  const params = new URLSearchParams({
    bookingNumber,
  })

  return `${bookingBaseUrl}?${params.toString()}`
}
